import { render, staticRenderFns } from "./verifile.vue?vue&type=template&id=6484d056&scoped=true&"
import script from "./verifile.vue?vue&type=script&lang=js&"
export * from "./verifile.vue?vue&type=script&lang=js&"
import style0 from "./verifile.vue?vue&type=style&index=0&id=6484d056&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6484d056",
  null
  
)

export default component.exports